import { PaginatedList } from '@/api/models/common/paginatedList'
import { PtfBeneficiaireBeneficiaire, PtfBeneficiaireBeneficiaireCreate } from '@/api/models/ptfBeneficiaire/Beneficiaire'
import { PtfBeneficiaireMeetingGrouped } from '@/api/models/ptfBeneficiaire/MeetingGrouped'
import api from '@/libs/axios'

const baseUrl = "PlateformeBeneficiaireBeneficiaires"

export default class PtfBeneficiaireBeneficiairesResource {

  public async listBeneficiaires(
    pagenumber?: number,
    pagesize?: number,
    search?: string
  ): Promise<PaginatedList<PtfBeneficiaireBeneficiaire>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append("PageNumber", pagenumber.toString());
    if (pagesize) params.append("PageSize", pagesize.toString());
    if (search && search.length) params.append("Search", search?.toString());

    const response = await api.get(`${baseUrl}/listBeneficiaires`, { params: params });
    
    return response.data;
  }

  public async listMeetingsByBeneficiaireId(
    beneficiaireId: string, 
    dateDebut: string, 
    dateFin: string
  ): Promise<PtfBeneficiaireMeetingGrouped[]> {
    const params = new URLSearchParams();

    if (dateDebut) params.append("DateDebut", dateDebut.toString());
    if (dateFin) params.append("DateFin", dateFin.toString());

    const response = await api.get(`${baseUrl}/listMeetings/${beneficiaireId}`, { params: params });

    return response.data;
  }  

  public async getBeneficiaireById(beneficiaireId: string): Promise<PtfBeneficiaireBeneficiaire> {
    const response = await api.get(`${baseUrl}/getBeneficiaire/${beneficiaireId}`);
    
    return response.data;
  }

  public async create(data: PtfBeneficiaireBeneficiaireCreate): Promise<string> {
    const response = await api.post(`${baseUrl}/createBeneficiaire`, data);
    return response.data;
  }
}
